import { Card, CardContent } from '@/components/ui/card';
import { HandHeart, LockKeyhole, WandSparkles, Snail } from 'lucide-react';

const AboutUsSection = () => {
  const values = [
    {
      icon: <HandHeart className="w-9 h-9" strokeWidth={1} />,
      title: "Presence over Perfection",
      description: "It’s not about doing everything right. It’s about showing up gently, consistently, and with care."
    },
    {
      icon: <LockKeyhole className="w-9 h-9" strokeWidth={1} />,
      title: "Privacy, Always",
      description: "Your moments are yours. Wabisabi is a privacy-first space. We don’t sell your data. We don’t mine it. And we never will."
    },
    {
      icon: <WandSparkles className="w-9 h-9" strokeWidth={1} />,
      title: "Mindful Technology",
      description: "AI shouldn’t replace connection, it should support it. Wabisabi uses technology to help you remember what matters."
    },
    {
      icon: <Snail className="w-9 h-9" strokeWidth={1} />,
      title: "Slow and Intentional",
      description: "Relationships don’t need speed — they need intention. Wabisabi encourages thoughtful intentions over instant reactions."
    }
  ];

  return (
    <section className="section-padding bg-white relative overflow-hidden mx-[20px] md:mx-0 rounded-[8px] md:rounded-none">

      <div className="relative z-10 mx-[20px] md:max-w-7xl md:mx-auto">
        {/* Values Section */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <h2
              className="font-bold text-[#6C4F77] responsive-title leading-none"
              style={{
                fontSize: '28px',
                letterSpacing: '-1px',
                verticalAlign: 'middle'
              }}
            >
              <style dangerouslySetInnerHTML={{
                __html: `
                  @media (min-width: 768px) {
                    .responsive-title {
                      font-size: 60px !important;
                      letter-spacing: -2px !important;
                    }
                  }
                `
              }} />
              Our Values
            </h2>
          </div>
          <p className="text-[#2C2C2C]/80 max-w-2xl mx-auto mb-5" style={{ fontSize: '14px', fontFamily: 'Euclid Circular A' }}>
            <style dangerouslySetInnerHTML={{
              __html: `
                @media (min-width: 768px) {
                  .text-center p {
                    font-size: 1.25rem !important;
                  }
                }
              `
            }} />
            What guides us, and why we built this
          </p>

          <div className="grid gap-2 grid-cols-1 md:grid-cols-4 mb-7" style={{ overflow: 'visible' }}>
            {values.map((value, index) => (
              <Card key={index} className="text-center bg-transparent border-none shadow-none" style={{ overflow: 'visible' }}>
                <CardContent className="p-2 py-6 md:py-[50px] md:p-10" style={{ overflow: 'visible' }}>
                  <div className="mb-3 md:mb-6">
                    <div className="text-[#6C4F77] mb-5">
                      {value.icon}
                    </div>
                    <h3 className="font-semibold text-[#6C4F77] text-left text-base md:text-[24px]">{value.title}</h3>
                  </div>
                  <p className="text-[#262729] text-sm md:text-[18px] leading-normal md:leading-tight text-left font-normal" style={{ fontFamily: 'Euclid Circular A', fontWeight: 400 }}>{value.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Image */}
          <div className="mt-8">
            <img
              src="/images/img1.jpg"
              alt="Our Values"
              className="w-full border border-black rounded-[8px] object-cover"
              style={{ objectPosition: 'center 25%' }}
            />
            <style dangerouslySetInnerHTML={{
              __html: `
                .mt-8 img {
                  height: 353px;
                  transform: scaleX(-1);
                  object-position: center 25%;
                }
                @media (min-width: 768px) {
                  .mt-8 img {
                    height: 650px !important;
                  }
                }
              `
            }} />
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
